import React from 'react';
import {
  Route,
  Routes,
  Navigate,
  useParams,
} from 'react-router';
import i18n from 'i18next';

import {
  Flex,
} from 'web-styled';

import {
  ContentWrapper,
  NavigationTabs,
} from 'web-components';

import SearchList from './SearchList';

const tabs = ['all', 'exercises', 'workouts', 'programs', 'documents'];
const SearchResults = () => {
  const params = useParams();
  const { searchQuery } = params;

  const getTabs = () => tabs.map(
    name => ({
      name: i18n.t(name),
      to: `/search/${searchQuery}/${name}`,
    }),
  );

  return (
    <ContentWrapper
      header={(
        <Flex
          fillSpace
          align="center"
          justify="space-between"
        >
          <Flex
            align="center"
            spacing={10}
          >
            <NavigationTabs
              tabs={getTabs()}
            />
          </Flex>
        </Flex>
    )}
    >
      <Flex
        column
        fillSpace
        spacing={10}
      >
        <Routes>
          <Route
            index
            element={<Navigate to="all" />}
          />
          {tabs.map(tab => (
            <Route
              key={tab}
              path={tab}
              element={(
                <SearchList
                  tabName={tab}
                  searchQuery={searchQuery || ''}
                />
              )}
            />
          ))}
        </Routes>
      </Flex>
    </ContentWrapper>
  );
};

export default SearchResults;
